// extracted by mini-css-extract-plugin
export default {"root":"ChipsSelected_root__NVREG","text":"ChipsSelected_text__30z1-","imgButton":"ChipsSelected_imgButton__rBzw5","imgClose":"ChipsSelected_imgClose__mUEtJ"};